import React from 'react'
import GenerateLink from './generatepaymentlinkPopup'
import GenerateLinkAbhicash from './generatepaymentlinkPopupAbhicash'
import { Company_DATA } from '../../../../layouts/MainTenantconfig'
export default function Main({ openGenerateLink, emiDetail, userDetail, admin, tenant }) {
    return (
        <>
            {
                tenant?.COMPANY_NAME == Company_DATA?.ABHICASH ?
                    <GenerateLinkAbhicash
                        openGenerateLink={openGenerateLink}
                        emiDetail={emiDetail}
                        userDetail={userDetail}
                        admin={admin}
                        tenant={tenant}
                    />
                    :
                    <GenerateLink
                        openGenerateLink={openGenerateLink}
                        emiDetail={emiDetail}
                        userDetail={userDetail}
                        admin={admin}
                        tenant={tenant}
                    />
            }
        </>
    )
}
